// extracted by mini-css-extract-plugin
export default {"box-wrapper":"Resources_box-wrapper__2Wsm0","box":"Resources_box__wqiWp","button-wrapper":"Resources_button-wrapper__OPTEz"};